import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  HomiSettings,
  EloSyncResults,
} from '@lyceo/shared/homi-settings/util-models';

export const HomiSettingsActions = createActionGroup({
  source: 'Homi Settings API',
  events: {
    'Get Settings': emptyProps(),
    'Get Settings By Pupil Id': props<{ pupilId: string }>(),
    'Get Settings Success': props<{ settings: HomiSettings }>(),
    'Get Settings Failure': props<{ error: Error }>(),
    'Refresh Settings': emptyProps(),
    'Refresh Settings Success': props<{ settings: HomiSettings }>(),
    'Refresh Settings Failure': props<{ error: Error }>(),
    'Sync Elo': props<{ pupilId: string }>(),
    'Sync Elo Success': props<{ results: EloSyncResults }>(),
    'Sync Elo Failure': props<{ error: Error }>(),
    'Connect Elo Success': emptyProps(),
    'Connect Elo Failure': emptyProps(),
  },
});

export const EloActions = createActionGroup({
  source: 'Elo',
  events: {
    'Connect Elo Clicked': emptyProps(),
    'Sync Elo Clicked': emptyProps(),
  },
});
